import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api-client';
import type { ApiDocumentsResponse } from '@/lib/adapters/documents';

export interface DocumentFilters {
  clientId?: string;
  /** Prisma String: receipt, invoice, statement or timesheet. */
  type?: string;
  page?: number;
  limit?: number;
}

/**
 * Documents, newest first, optionally filtered. `enabled: false` holds the request, e.g. until a tab is shown.
 * `keepPrevious` keeps the last result on screen while a changed filter loads, for a list the user filters in place.
 */
export function useDocuments(filters: DocumentFilters = {}, options: { enabled?: boolean; keepPrevious?: boolean } = {}) {
  const params = new URLSearchParams();
  if (filters.clientId) params.set('clientId', filters.clientId);
  if (filters.type) params.set('type', filters.type);
  if (filters.page) params.set('page', String(filters.page));
  if (filters.limit) params.set('limit', String(filters.limit));

  const query = params.toString();
  const path = `/documents${query ? `?${query}` : ''}`;

  return useQuery({
    queryKey: ['documents', filters],
    queryFn: () => api.get<ApiDocumentsResponse>(path),
    enabled: options.enabled ?? true,
    placeholderData: options.keepPrevious ? keepPreviousData : undefined,
  });
}
